// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.hiring-container---- {
    width: 86%;
    margin: auto;
    margin-top: 120px;
    background-color: #ffffff;
  }

  .career-banner-image-style {
    width: 100%;
    height: 424px;
    border-radius: 10px;
  }
  
  /* Title & Subtitle */
  .hiring-title-text-style {
    font-size: 48px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    margin-top: 64px;
  }
  
  .hiring-subtitle {
    font-size: 22px;
    font-weight: 500;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    margin-bottom: 20px;
  }
  
  /* Banner Image */
  .banner img {
    width: 100%;
    max-height: 250px;
    object-fit: cover;
    border-radius: 10px;
  }
  
  /* Section Titles */
  .section-title {
    font-size: 22px;
    margin-top: 40px;
  }
  
  .section-subtitle {
    font-size: 14px;
    color: #777;
    margin-bottom: 20px;
  }
  
  /* Benefits Section */
  .benefits-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    margin-bottom: 40px;
    transition: transform 0.3s ease-in-out;
  }

  .benefits-container:hover {
    transform: translateY(-5px);
}
  
  .benefit-card {
    background: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .benefit-card span {
    font-size: 24px;
    display: block;
    margin-bottom: 10px;
  }

  .benifit-card-text-style {
    font-size: 22px;
    font-weight: 700;
    color: #000000;
    font-family: "Plus Jakarta Sans", serif;
    margin-top: 30px;
    margin-bottom: 60px;
  }
  
  
  /* Job Listings */
  .job-listings {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    margin-top: 64px;
    margin-bottom: 100px;
  }
  
  .job-card {
    background: #F8F9FA;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .job-card h4 {
    margin-bottom: 10px;
  }
  
  .job-card p {
    font-size: 14px;
    color: #444;
    margin-bottom: 10px;
  }
  
  /* Apply Button */
  .apply-btn {
    background: #28a745;
    color: white;
    border: none;
    padding: 10px 15px;
    font-size: 14px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 52px;
  }

  .job-card-parent-text-container {
    text-align: left;
  }

  .job-card-bold-text-style {
    text-align: left;
    font-size: 28px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
  }

  .job-card-medium-text-style {
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
  }
  .job-card-light-text-style {
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
  }
  
  .apply-btn:hover {
    background: #218838;
    margin-top: 52px;
  }

  .join-us-image-style {
    height: 150px;
    width: 150px;
  }


  /* Modal Overlay */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* Modal Content */
  .modal-content {
    background: white;
    padding: 14px;
    border-radius: 10px;
    width: 400px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    text-align: center;
  }
  
  /* Modal Inputs */
  .modal-content input,
  .modal-content select {
    width: 100%;
    padding: 10px;
    margin: 5px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  /* Modal Buttons */
  .modal-actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 44px;
  }
  
  .modal-actions button {
    width: 50%;
    padding: 10px 15px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    font-family: "Plus Jakarta Sans", serif;
    border-radius: 5px;
    transition: transform 0.3s ease-in-out;
  }
  
  .modal-actions button:first-child {
    background: #ccc;
  }
  
  .modal-actions button:last-child {
    background: #007bff;
    color: white;
  }
  
  .modal-actions button:hover {
    opacity: 0.8;
    transform: translateY(-3px);
  }

  .career-page-top-side-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #DEE2E6; /* Correct syntax */
}

.career-page-text-input-div {
  height: 40px;
  border: 1px solid #DEE2E6
}

.career-page-text-style {
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 700;
  color: #212529;
  font-family: "Plus Jakarta Sans", serif;
}

  .career-page-modal-close-icon {
    height: 20px;
    width: 20px;
    margin-bottom: 24px;
  }

  .text-input-label-text-style {
    display: flex;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
  }
  
  .career-page-form-style {
    margin-top: 16px;
    padding: 10px;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .benefits-container {
      grid-template-columns: repeat(2, 1fr);
    }
  
    .job-listings {
      flex-direction: column;
    }
  }
  
  @media (max-width: 480px) {
    .benefits-container {
      grid-template-columns: 1fr;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Career/career.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;AAC/B;;EAEE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;EACrB;;;EAGA,iBAAiB;EACjB;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;EACzC;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;EACzC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;;EAGA,kBAAkB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;;IAEE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC,EAAE,mBAAmB;AACzD;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;EAEE;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE;MACE,qCAAqC;IACvC;;IAEA;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF","sourcesContent":["/* Main Container */\n.hiring-container---- {\n    width: 86%;\n    margin: auto;\n    margin-top: 120px;\n    background-color: #ffffff;\n  }\n\n  .career-banner-image-style {\n    width: 100%;\n    height: 424px;\n    border-radius: 10px;\n  }\n  \n  /* Title & Subtitle */\n  .hiring-title-text-style {\n    font-size: 48px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    margin-top: 64px;\n  }\n  \n  .hiring-subtitle {\n    font-size: 22px;\n    font-weight: 500;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    margin-bottom: 20px;\n  }\n  \n  /* Banner Image */\n  .banner img {\n    width: 100%;\n    max-height: 250px;\n    object-fit: cover;\n    border-radius: 10px;\n  }\n  \n  /* Section Titles */\n  .section-title {\n    font-size: 22px;\n    margin-top: 40px;\n  }\n  \n  .section-subtitle {\n    font-size: 14px;\n    color: #777;\n    margin-bottom: 20px;\n  }\n  \n  /* Benefits Section */\n  .benefits-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 15px;\n    margin-bottom: 40px;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .benefits-container:hover {\n    transform: translateY(-5px);\n}\n  \n  .benefit-card {\n    background: #f9f9f9;\n    padding: 15px;\n    border-radius: 10px;\n    text-align: center;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .benefit-card span {\n    font-size: 24px;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  .benifit-card-text-style {\n    font-size: 22px;\n    font-weight: 700;\n    color: #000000;\n    font-family: \"Plus Jakarta Sans\", serif;\n    margin-top: 30px;\n    margin-bottom: 60px;\n  }\n  \n  \n  /* Job Listings */\n  .job-listings {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 64px;\n    margin-bottom: 100px;\n  }\n  \n  .job-card {\n    background: #F8F9FA;\n    border-radius: 10px;\n    padding: 20px;\n    text-align: center;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .job-card h4 {\n    margin-bottom: 10px;\n  }\n  \n  .job-card p {\n    font-size: 14px;\n    color: #444;\n    margin-bottom: 10px;\n  }\n  \n  /* Apply Button */\n  .apply-btn {\n    background: #28a745;\n    color: white;\n    border: none;\n    padding: 10px 15px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 52px;\n  }\n\n  .job-card-parent-text-container {\n    text-align: left;\n  }\n\n  .job-card-bold-text-style {\n    text-align: left;\n    font-size: 28px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n  }\n\n  .job-card-medium-text-style {\n    text-align: left;\n    font-size: 18px;\n    font-weight: 600;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n  }\n  .job-card-light-text-style {\n    text-align: left;\n    font-size: 18px;\n    font-weight: 400;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n  }\n  \n  .apply-btn:hover {\n    background: #218838;\n    margin-top: 52px;\n  }\n\n  .join-us-image-style {\n    height: 150px;\n    width: 150px;\n  }\n\n\n  /* Modal Overlay */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  /* Modal Content */\n  .modal-content {\n    background: white;\n    padding: 14px;\n    border-radius: 10px;\n    width: 400px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    text-align: center;\n  }\n  \n  /* Modal Inputs */\n  .modal-content input,\n  .modal-content select {\n    width: 100%;\n    padding: 10px;\n    margin: 5px 0;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  /* Modal Buttons */\n  .modal-actions {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    margin-top: 44px;\n  }\n  \n  .modal-actions button {\n    width: 50%;\n    padding: 10px 15px;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    font-family: \"Plus Jakarta Sans\", serif;\n    border-radius: 5px;\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .modal-actions button:first-child {\n    background: #ccc;\n  }\n  \n  .modal-actions button:last-child {\n    background: #007bff;\n    color: white;\n  }\n  \n  .modal-actions button:hover {\n    opacity: 0.8;\n    transform: translateY(-3px);\n  }\n\n  .career-page-top-side-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #DEE2E6; /* Correct syntax */\n}\n\n.career-page-text-input-div {\n  height: 40px;\n  border: 1px solid #DEE2E6\n}\n\n.career-page-text-style {\n  margin-bottom: 24px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #212529;\n  font-family: \"Plus Jakarta Sans\", serif;\n}\n\n  .career-page-modal-close-icon {\n    height: 20px;\n    width: 20px;\n    margin-bottom: 24px;\n  }\n\n  .text-input-label-text-style {\n    display: flex;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 500;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n  }\n  \n  .career-page-form-style {\n    margin-top: 16px;\n    padding: 10px;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .benefits-container {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  \n    .job-listings {\n      flex-direction: column;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .benefits-container {\n      grid-template-columns: 1fr;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
